import { Controller } from '@hotwired/stimulus'

// Sister-site links (vehileaks/vehisales) must stay query-free in the HTML:
// both sites' robots.txt block every query-string URL, so hrefs carrying
// UTM/filter params pile up in Search Console as "Blocked by robots.txt"
// and never validate. The crawler (including Google's JS rendering — it never
// interacts) sees the clean, indexable href; the full query is attached only
// on real user interaction. pointerdown/touchstart/keydown all fire before
// the browser reads the href for navigation, covering left/middle/cmd-click,
// touch and keyboard activation alike.
export default class extends Controller {
  static values = { query: String }

  connect() {
    this.apply = this.apply.bind(this)
    this.element.addEventListener('pointerdown', this.apply)
    this.element.addEventListener('touchstart', this.apply, { passive: true })
    this.element.addEventListener('keydown', this.apply)
  }

  disconnect() {
    this.element.removeEventListener('pointerdown', this.apply)
    this.element.removeEventListener('touchstart', this.apply)
    this.element.removeEventListener('keydown', this.apply)
  }

  apply(event) {
    if (!this.queryValue) return
    // keydown fires for Tab/arrow keys too — only Enter activates a link.
    if (event && event.type === 'keydown' && event.key !== 'Enter') return
    const url = new URL(this.element.href, window.location.origin)
    new URLSearchParams(this.queryValue).forEach((v, k) => url.searchParams.set(k, v))
    this.element.href = url.toString()
  }
}
